import { RecurringOrdersComponent } from './recurring-orders.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SharedModule } from 'app/shared/shared.module';
import { RecurringOrdersListComponent } from './recurring-orders-list/recurring-orders-list.component';
import { MomentModule } from 'ngx-moment';
import { RecurringOrderCreateComponent } from './recurring-order-create/recurring-order-create.component';
import { RecurringOrderDetailComponent } from './recurring-order-detail/recurring-order-detail.component';
import { RecurringOrderEditComponent } from './recurring-order-edit/recurring-order-edit.component';

@NgModule({
    declarations: [
        RecurringOrdersComponent,
        RecurringOrdersListComponent,
        RecurringOrderCreateComponent,
        RecurringOrderDetailComponent,
        RecurringOrderEditComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        ReactiveFormsModule,
        MomentModule
    ]
})
export class RecurringOrdersModule { }
